import type {PodRequestFn} from '../usePodRequest';

const OUTLOOK_ADD_IN_JOB_AUTOCOMPLETE_PATH = '/outlook_add_in/job_autocomplete';

export type OutlookJobJson = {
  id: number;
  title: string;
  company_name: string | null;
  created_at: string;
};

export type OutlookJobAutocompleteJson = {
  jobs: OutlookJobJson[];
};

export const buildOutlookJobAutocompletePath = (
  agencyId: number,
  options: {
    query?: string;
  } = {}
): string => {
  const params = new URLSearchParams();
  params.set('agency_id', String(agencyId));
  const query = options.query?.trim();
  if (query) {
    params.set('query', query);
  }
  return `${OUTLOOK_ADD_IN_JOB_AUTOCOMPLETE_PATH}?${params.toString()}`;
};

export const fetchOutlookJobAutocomplete = async (
  request: PodRequestFn,
  agencyId: number,
  options: {
    query?: string;
  } = {}
): Promise<OutlookJobAutocompleteJson> => {
  const path = buildOutlookJobAutocompletePath(agencyId, options);
  const response = await request(path);
  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || `Request failed (${response.status})`);
  }
  return JSON.parse(text) as OutlookJobAutocompleteJson;
};
